export enum ConnectorType {
    HUBRISE = 'hubrise',
    ZELTY = 'zelty',
    CARREPOS = 'carrepos',
    DELIVERECT = 'deliverect',
    SYMBIOZ = 'symbioz',
    TILLER = 'tiller',
    LEO2 = 'leo2',
    LIGHTSPEED = 'lightspeed',
    RUSHOUR = 'rushour',
    DELIVEROO = 'deliveroo',
    KEYTCHENS = 'keytchens',
    UNTILL = 'untill',
    PI = 'pi',
    NO_CONNECTOR = 'no_connector',
    OPOSSUM = 'opossum',
    ALLEATONE = "alleatone",
    SQUARE = "square",
    ORCHESTRA = "orchestra",

    KILLBILLS = "killbills",
    LABWARE = "labware",

    MANUAL_INTEGRATION = "manual_integration",

    // Not implemented for now in conector but only in printer or to retrieve orders
    JALIA = "jalia",
    ADDITION = "addition",
    CLYO = "clyo",
    TRIVEC = "trivec",
    POPINA = "popina",
    // TODO: check if related to a version instead
    POPINA_TEXT = "popina_text",
    VEGA = "vega",
    PHARE = "phare",
    STARVISION = "starvision",
    CASHMAG = "cashmag",
    VENTAP = "ventap",
    OTHER = "other",
    CASHPAD = "cashpad",
    BOXAPOS = "boxapos",
    VECTRON = "vectron",

    // TAP Connectors
    TWELVE = "twelve",
    MPLUS = "mplus",
    BORK = "bork",
    // UNTILL = 'untill',
    TAPP_SENSOR = "tapp_sensor",
    TAPP_API_GATEWAY = "tapp_api_gateway",
    TAPP_LIGHTSPEED = "tapp_lightspeed",
    TAPP_LIGHTSPEED_OAUTH2 = "tapp_lightspeed_oauth2",
    GASTROFIX = "gastrofix",
    NEXT_TO_FOOD = "ntf",
    UNITOUCH = "unitouch",
    BOOQ = "booq",
    DEBUUT = "debuut",
    ZETTLE = "zettle",
    EPOS_NOW = "epos_now",
}

export const connectorIdToType: { [connectorId: string]: ConnectorType } = {
    "02": ConnectorType.ADDITION,
    "03": ConnectorType.TRIVEC,
    "04": ConnectorType.KILLBILLS,
    "05": ConnectorType.LABWARE,
    "06": ConnectorType.JALIA,
    "07": ConnectorType.POPINA,

    // Germany
    "08": ConnectorType.VECTRON,

    // Netherlands
    "09": ConnectorType.TWELVE,
    "10": ConnectorType.MPLUS,
    "11": ConnectorType.BORK,
    "12": ConnectorType.TAPP_API_GATEWAY,
    "13": ConnectorType.TAPP_SENSOR,
    "14": ConnectorType.BOOQ,
    "15": ConnectorType.GASTROFIX,
    "16": ConnectorType.TAPP_LIGHTSPEED,
    "17": ConnectorType.TAPP_LIGHTSPEED_OAUTH2,
    "18": ConnectorType.NEXT_TO_FOOD,
    "19": ConnectorType.UNITOUCH,
    "20": ConnectorType.UNTILL,
    "21": ConnectorType.DEBUUT,
    "22": ConnectorType.ZETTLE,

    // UK
    "23": ConnectorType.EPOS_NOW
}

export const connectorLogos: Record<ConnectorType, string | null> = {
    [ConnectorType.MANUAL_INTEGRATION]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/interdit.png",
    [ConnectorType.HUBRISE]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/HubRise%20Logo.png",
    [ConnectorType.KILLBILLS]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/Logo%20KillBills%20dark%20blue.webp",
    [ConnectorType.TILLER]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/Tiller-logo-1.png",
    [ConnectorType.UNTILL]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/Untill.png",
    [ConnectorType.ZELTY]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/Zelty_idZnjim-Po_1.png",
    [ConnectorType.CARREPOS]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/carre___pos_logo__1_.png",
    [ConnectorType.DELIVERECT]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/deliverect-logo.png",
    [ConnectorType.DELIVEROO]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/deliveroo-seeklogo.png",
    [ConnectorType.LABWARE]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/labware.png",
    [ConnectorType.LEO2]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/leo2.jpeg",
    [ConnectorType.LIGHTSPEED]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/lightspeed.png",
    [ConnectorType.KEYTCHENS]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/logo-keytchens-black.228722ff.png",
    [ConnectorType.ORCHESTRA]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/logo-orchestra-pdv-transparent.png",
    [ConnectorType.SYMBIOZ]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/logo-symbioz-vertical.png",
    [ConnectorType.PI]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/pi.png",
    [ConnectorType.RUSHOUR]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/rushour.png",
    [ConnectorType.SQUARE]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/square.png",
    [ConnectorType.TRIVEC]: "https://storage.googleapis.com/my-lemonade.appspot.com/images/trivec.svg",
    [ConnectorType.OPOSSUM]: null,
    [ConnectorType.ALLEATONE]: null,
    [ConnectorType.CASHPAD]: null,
    [ConnectorType.CASHMAG]: null,
    [ConnectorType.BOXAPOS]: null,
    [ConnectorType.VENTAP]: null,
    [ConnectorType.STARVISION]: null,
    [ConnectorType.PHARE]: null,
    [ConnectorType.VEGA]: null,
    [ConnectorType.POPINA]: null,
    [ConnectorType.POPINA_TEXT]: null,
    [ConnectorType.CLYO]: null,
    [ConnectorType.ADDITION]: null,
    [ConnectorType.JALIA]: null,
    [ConnectorType.MPLUS]: null,
    [ConnectorType.BORK]: null,
    [ConnectorType.TWELVE]: null,
    [ConnectorType.TAPP_SENSOR]: null,
    [ConnectorType.TAPP_API_GATEWAY]: null,
    [ConnectorType.TAPP_LIGHTSPEED]: null,
    [ConnectorType.TAPP_LIGHTSPEED_OAUTH2]: null,
    [ConnectorType.GASTROFIX]: null,
    [ConnectorType.NEXT_TO_FOOD]: null,
    [ConnectorType.UNITOUCH]: null,
    [ConnectorType.BOOQ]: null,
    [ConnectorType.DEBUUT]: null,
    [ConnectorType.ZETTLE]: null,
    [ConnectorType.NO_CONNECTOR]: null,
    [ConnectorType.OTHER]: null,
    [ConnectorType.VECTRON]: null,
    [ConnectorType.EPOS_NOW]: null,
}

export const connectorVisibility: Record<ConnectorType, boolean> = {
    [ConnectorType.MANUAL_INTEGRATION]: true,
    [ConnectorType.HUBRISE]: true,
    [ConnectorType.KILLBILLS]: true,
    [ConnectorType.TILLER]: true,
    [ConnectorType.UNTILL]: true,
    [ConnectorType.ZELTY]: true,
    [ConnectorType.CARREPOS]: true,
    [ConnectorType.DELIVERECT]: true,
    [ConnectorType.DELIVEROO]: true,
    [ConnectorType.LABWARE]: true,
    [ConnectorType.LEO2]: true,
    [ConnectorType.LIGHTSPEED]: true,
    [ConnectorType.KEYTCHENS]: true,
    [ConnectorType.ORCHESTRA]: true,
    [ConnectorType.SYMBIOZ]: true,
    [ConnectorType.PI]: true,
    [ConnectorType.RUSHOUR]: true,
    [ConnectorType.SQUARE]: true,
    [ConnectorType.TRIVEC]: true,
    [ConnectorType.OPOSSUM]: true,
    [ConnectorType.ALLEATONE]: true,
    [ConnectorType.CASHPAD]: true,
    [ConnectorType.CASHMAG]: false,
    [ConnectorType.BOXAPOS]: false,
    [ConnectorType.VENTAP]: false,
    [ConnectorType.STARVISION]: false,
    [ConnectorType.PHARE]: false,
    [ConnectorType.VEGA]: false,
    [ConnectorType.POPINA]: false,
    [ConnectorType.POPINA_TEXT]: false,
    [ConnectorType.CLYO]: false,
    [ConnectorType.ADDITION]: true,
    [ConnectorType.JALIA]: false,
    [ConnectorType.MPLUS]: false,
    [ConnectorType.BORK]: false,
    [ConnectorType.TWELVE]: false,
    [ConnectorType.TAPP_SENSOR]: false,
    [ConnectorType.TAPP_API_GATEWAY]: false,
    [ConnectorType.TAPP_LIGHTSPEED]: false,
    [ConnectorType.TAPP_LIGHTSPEED_OAUTH2]: false,
    [ConnectorType.GASTROFIX]: false,
    [ConnectorType.NEXT_TO_FOOD]: false,
    [ConnectorType.UNITOUCH]: false,
    [ConnectorType.BOOQ]: false,
    [ConnectorType.DEBUUT]: false,
    [ConnectorType.ZETTLE]: false,
    [ConnectorType.NO_CONNECTOR]: false,
    [ConnectorType.OTHER]: false,
    [ConnectorType.VECTRON]: false,
    [ConnectorType.EPOS_NOW]: false,
}

export interface ConnectorListItem {
    name: string;
    logoUrl?: string;
    connectorType: ConnectorType;
}
